<template>
  <div class="qualityContain">
    <div class="returnFunc">
      <el-button class="goBack" @click="goBack">返回</el-button>
      <el-button v-show="downloadExcelShow" class="lookUp" type="danger" @click="download"
        icon="el-icon-download">下载</el-button>
      <el-button v-show="!downloadExcelShow" class="lookUp" type="warning" :loading="true" plain>下载..</el-button>
      <!-- <el-button plain @click="goBack">返回</el-button> -->
    </div>
    <el-button class="workBack" type="danger" @click="goToMonitorRe">作业回放</el-button>
    <div class="listContentDay">
      <el-dialog title="切换工程" :visible.sync="dialogTableVisible">
        <el-table :data="projList">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="address" label="工程地址"></el-table-column>
          <el-table-column label="设置" width="150">
            <template slot-scope="scope">
              <span class="setProject" @click="toActive(scope.row.id)" v-if="scope.row.active == 0">设为当前工程</span>
              <span class="lookMore" v-if="scope.row.active == 1">当前工程</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <div class="changeText">当前工程：{{ nowPro }}</div>
      <el-button class="changePro" type="primary" @click="openProjectSelector" plain>切换工程</el-button>
      <div class="searchCon searchContent">
        <span class="searchInputText">作业选择</span>
        <el-select v-model="workId" placeholder="请选择作业">
          <el-option v-for="item in workList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>

        <!-- <span class="searchInputText">日期</span>
        <el-date-picker
          size="medium"
          v-model="duration"
          @change="dateChange"
          type="daterange"
          range-separator="—"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker> -->

        <el-button type="danger" @click="doSearchClick">确认</el-button>
        <!-- <el-button type="info" @click="resetSearch" plain>重置</el-button> -->
      </div>
      <div class="qualityCon">
        <div class="projectInfo">
          <div class="blockHeader">
            <div class="redBlock"></div>
            <div class="headerText">施工项目信息</div>
          </div>
          <div class="line" style="
              height: 1px;
              background-color: #e1e1e1;
              width: 100%;
              margin: 0 auto;
            "></div>
          <div class="blockContent" style="margin-top: 24px">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">施工单位</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectInfoVo.consUnit }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">天气状况</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectInfoVo.weather }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业时间段</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectInfoVo.timePeriod }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">{{ projectTypeShow ? '施工层' : '施工区间' }}</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectTypeShow ? projectInfoVo.workLayer : projectInfoVo.workInterval
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">{{ projectTypeShow ? '总作业面积' : '施工层' }}</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectTypeShow ? projectInfoVo.sumArea : projectInfoVo.workLayer }}
                    {{ projectTypeShow ? ' ㎡' : '' }}</span>
                </div>
              </div>
              <!-- <div class="item_type1" v-show="!projectTypeShow">
                <div class="itemLeft">路面宽度/施工长度</div>
                <div class="itemRight">
                  <span class="infoShow">{{projectInfoVo.roadWidth}} m / {{ projectInfoVo.roadLength }} m </span>
                </div>
              </div>
              <div class="item_type1" v-show="projectTypeShow">
                <div class="itemLeft">已作业面积</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectInfoVo.roadLength}} ㎡</span>
                </div>
              </div> -->
              <div class="item_type1">
                <div class="itemLeft">{{ projectTypeShow ? '已作业面积' : '路面宽度/施工长度' }}</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectTypeShow ? projectInfoVo.curArea : projectInfoVo.roadWidth }}
                    {{ projectTypeShow ? ' ㎡' : ' m / ' }} {{ projectTypeShow ? '' : projectInfoVo.roadLength }} {{
                      projectTypeShow ? '' : ' m' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="projectInfo">
          <div class="blockHeader">
            <div class="redBlock"></div>
            <div class="headerText">施工设备信息</div>
          </div>
          <div class="line" style="
              height: 1px;
              background-color: #e1e1e1;
              width: 100%;
              margin: 0 auto;
            "></div>
          <div class="listContain">
            <div class="tablelistBody">
              <el-table :data="dataList" style="width: 100%" size="medium">
                <!-- <el-table-column
                  label="序号"
                  width="120"
                ><template slot-scope="scope">
                    <span class="orderShow">{{scope.row.index}}</span>
                </template></el-table-column> -->
                <el-table-column prop="equipModel" label="设备类型" width=""></el-table-column>
                <el-table-column prop="equipCode" label="设备编号" width=""></el-table-column>
                <el-table-column prop="stageType" label="作业类型" width=""></el-table-column>
                <el-table-column label="平均速度" width="">
                  <template slot-scope="scope">
                    <span>{{ scope.row.averageSpeed ? scope.row.averageSpeed : '--' }} {{ scope.row.stageType == '摊铺' ?
                      'm/min' : 'km/h' }}</span></template></el-table-column>
                <el-table-column label="峰值速度" width="">
                  <template slot-scope="scope">
                    <span>{{ scope.row.maxSpeed ? scope.row.maxSpeed : '--' }} {{ scope.row.stageType == '摊铺' ?
                      'm/min' : 'km/h' }}</span>
                  </template></el-table-column>
                <el-table-column label="超速占比" width=""><template slot-scope="scope">
                    <!-- <span>{{scope.row.overSpeedRatio?scope.row.overSpeedRatio*100:'--'}}%</span -->
                    <span>{{ scope.row.overSpeedRatio ? numberMul(scope.row.overSpeedRatio)
                      : scope.row.overSpeedRatio == 0 ? 0 : '--' }}%</span>
                  </template></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="projectInfo">
          <div class="blockHeader">
            <div class="redBlock"></div>
            <div class="headerText">施工质量整体评价</div>
          </div>
          <div class="line" style="
              height: 1px;
              background-color: #e1e1e1;
              width: 100%;
              margin: 0 auto;
            "></div>
          <div class="smallHeaderText" v-show="quality_1">1. 碾压遍数质量评价</div>
          <div class="blockContent" style="margin-top: 24px" v-show="quality_1">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">{{ projectTypeShow ? '设定遍数' : '初压设定遍数' }}</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectTypeShow ? quality_1.rollWorkStageExpectRollNum :
                    quality_1.initialStageExpectRollNum }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">{{ projectTypeShow ? '实际遍数' : '初压实际遍数' }}</div>
                <div class="itemRight">
                  <span class="infoShow">{{ projectTypeShow ? quality_1.rollWorkStageActualRollNum :
                    quality_1.initialStageActualRollNum }}</span>
                </div>
              </div>
              <div class="item_type1" v-show=!projectTypeShow>
                <div class="itemLeft">复压设定遍数</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_1.secondStageExpectRollNum }}</span>
                </div>
              </div>
              <div class="item_type1" v-show=!projectTypeShow>
                <div class="itemLeft">复压实际遍数</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_1.secondStageActualRollNum }}</span>
                </div>
              </div>
              <div class="item_type1" v-show=!projectTypeShow>
                <div class="itemLeft">终压设定遍数</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_1.thirdStageExpectRollNum }}</span>
                </div>
              </div>
              <div class="item_type1" v-show=!projectTypeShow>
                <div class="itemLeft">终压实际遍数</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_1.thirdStageActualRollNum }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">欠压率</div>
                <div class="itemRight">
                  <span class="infoShow">{{
                    quality_1.underVoltageRate ? numberMul(quality_1.underVoltageRate) : quality_1.underVoltageRate == 0 ?
                    0 : '--'
                  }}%</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">欠压位置</div>
                <div class="itemRight">
                  <span class="infoShow infoShowT">{{ underVoltagePileInfoList_BS }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">过压率</div>
                <div class="itemRight">
                  <span class="infoShow">{{
                    quality_1.overVoltageRate ? numberMul(quality_1.overVoltageRate) : quality_1.overVoltageRate == 0 ? 0
                    : '--'
                  }}%</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">过压位置</div>
                <div class="itemRight">
                  <span class="infoShow infoShowT">{{ overVoltagePileInfoList_BS }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">合格率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_1.qualifiedRate ? numberMul(quality_1.qualifiedRate) :
                    quality_1.qualifiedRate == 0 ? 0 : '--' }}%</span>
                </div>
              </div>
              <div class="item_type2">
              </div>
            </div>
          </div>
          <div class="smallHeaderText" v-show="quality_1"> 碾压遍数色阶图：</div>
          <div class="imageShow" v-show="quality_1">
            <RollLegend class="rollLegend" fontColor="black" legendType="1" @childExam="getRnExam"></RollLegend>
            <el-image style="width: 100%; height: 97%" :src="imageUrl_1" fit="scale-down" :preview-src-list="srcList_1">
              <div slot="error" class="image-slot">暂无数据</div>
            </el-image>
          </div>

          <div class="smallHeaderText" v-show="quality_2">2. ICV评价</div>
          <div class="blockContent" style="margin-top: 24px" v-show="quality_2">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">ICV设定值</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_2.expectIcv }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">平均值</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_2.averageIcv }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">欠压率</div>
                <div class="itemRight">
                  <span class="infoShow">{{quality_2.underVoltageRate?quality_2.underVoltageRate*100:quality_2.underVoltageRate==0?0:'--'}}%</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">欠压位置</div>
                <div class="itemRight">
                  <span class="infoShow infoShowT">{{underVoltagePileInfoList_ICV}}</span>
                </div>
              </div>
            </div> -->
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">欠压率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_2.underVoltageRate ? quality_2.underVoltageRate * 100 :
                    quality_2.underVoltageRate == 0 ? 0 : '--' }}%</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">欠压位置</div>
                <div class="itemRight">
                  <span class="infoShow infoShowT">{{ underVoltagePileInfoList_ICV }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">过压率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_2.overVoltageRate ? quality_2.overVoltageRate * 100 :
                    quality_2.overVoltageRate == 0 ? 0 : '--' }}%</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">过压位置</div>
                <div class="itemRight">
                  <span class="infoShow infoShowT">{{ overVoltagePileInfoList_ICV }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">合格率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_2.qualifiedRate ? quality_2.qualifiedRate * 100 :
                    quality_2.qualifiedRate == 0 ? 0 : '--' }}%</span>
                </div>
              </div>
              <div class="item_type2">
              </div>
            </div>
          </div>
          <div class="smallHeaderText" v-show="quality_2"> ICV分布色阶图：</div>
          <div class="imageShow" v-show="quality_2">
            <RollLegend class="rollLegend" fontColor="black" legendType="2" @childExam="getRnExam"></RollLegend>
            <el-image style="width: 100%; height: 97%" :src="imageUrl_2" fit="scale-down" :preview-src-list="srcList_2">
              <div slot="error" class="image-slot">暂无数据</div>
            </el-image>
          </div>

          <div class="smallHeaderText" v-show="!projectTypeShow">3. 摊铺、碾压温度评价</div>
          <div class="blockContent" style="margin-top: 24px" v-show="!projectTypeShow">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">摊铺温度设定</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.expectPaveStageTemperature }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">摊铺表面平均温度</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.averagePaveStageTemperature }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">初压温度设定</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.expectInitialStageTemperature }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">初压表面平均温度</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.averageInitialStageTemperature }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">复压温度设定</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.expectSecondStageTemperature }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">复压表面平均温度</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.averageSecondStageTemperature }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">终压温度设定</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.expectThirdStageTemperature }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">终压表面平均温度</div>
                <div class="itemRight">
                  <span class="infoShow">{{ quality_3.averageThirdStageTemperature }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">初压温度碾压合格率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ numberMul(quality_3.initialStageTemperatureQualifiedRate) }}%</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">摊铺温度合格率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ numberMul(quality_3.paveStageTemperatureQualifiedRate) }}%</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">初压低温率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ numberMul(quality_3.initialStageTemperatureUnderQualifiedRate) }}%</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">初压低温位置</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">摊铺低温率</div>
                <div class="itemRight">
                  <span class="infoShow">{{ numberMul(quality_3.paveStageTemperatureUnderQualifiedRate) }}%</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">摊铺低温位置</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="smallHeaderText" v-show="!projectTypeShow"> 摊铺温度色阶图：</div>
          <div class="imageShow" v-show="!projectTypeShow">
            <RollLegend class="rollLegend" fontColor="black" legendType="3" @childExam="getRnExam"></RollLegend>
            <el-image style="width: 100%; height: 97%" :src="imageUrl_3" fit="scale-down" :preview-src-list="srcList_3">
              <div slot="error" class="image-slot">暂无数据</div>
            </el-image>
          </div>
          <div class="smallHeaderText" v-show="!projectTypeShow"> 摊铺温度曲线图：</div>
          <div class="imageShow" v-show="!projectTypeShow"></div>

          <div class="smallHeaderText" v-show="!projectTypeShow">4. 摊铺厚度评价</div>
          <div class="blockContent" style="margin-top: 24px" v-show="!projectTypeShow">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">摊铺厚度设定值</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">平均值</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">厚度不足区域率</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">不足区域位置</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">厚度超高区域率</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">超高位置</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">厚度合格率</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type2">
              </div>
            </div>
          </div>
          <div class="smallHeaderText" v-show="!projectTypeShow"> 摊铺厚度曲线图：</div>
          <div class="imageShow" v-show="!projectTypeShow"></div>

          <div class="smallHeaderText" v-show="!projectTypeShow">5. 成品平整度评价</div>
          <div class="blockContent" style="margin-top: 24px" v-show="!projectTypeShow">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">平整度设定值</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">平均值</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">平整度不合格区域率</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">不合格区域位置</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">平整度合格率</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type1">
              </div>
            </div>
          </div>
          <div class="smallHeaderText" v-show="!projectTypeShow"> 平整度曲线图：</div>
          <div class="imageShow" v-show="!projectTypeShow"></div>

          <div class="smallHeaderText" v-show="!projectTypeShow">6. 材料离析评价</div>
          <div class="blockContent" style="margin-top: 24px" v-show="!projectTypeShow">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">离析占比</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
              <div class="item_type">
                <div class="itemLeft">离析区域位置</div>
                <div class="itemRight">
                  <span class="infoShow"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="smallHeaderText" v-show="!projectTypeShow"> 离析区域色阶图：</div>
          <div class="imageShow" v-show="!projectTypeShow"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RollLegend from "../../pages/quality/part/rollLegend";
import { Loading } from 'element-ui';
import { Message } from 'element-ui';
import { getDateSeconds } from "../../utils/commons";
import { getEnginList, getWorkQualityReportPdf, activeEngin, getWorks, getWorkQualityReport } from "../../utils/api";
export default {
  name: "app",
  data() {
    return {
      dialogTableVisible: false,
      downloadExcelShow: true,
      loadingInstance: '',
      picload: true,
      projList: [],
      workList: [],
      workId: '',
      nowPro: "",
      dataList: [],
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/engineeringCenter",
        },
        {
          name: "作业质量",
          path: "",
        },
      ],

      equipPerformanceInfoVoList: [], // 设备列表
      projectInfoVo: {}, // 施工项目信息
      qualityIndicatorVoList: [], // 施工质量信息

      quality_1: {},
      quality_2: {},
      quality_3: {
        expectPaveStageTemperature: null,
        averagePaveStageTemperature: null,
        expectInitialStageTemperature: null,
        averageInitialStageTemperature: null,
        expectSecondStageTemperature: null,
        averageSecondStageTemperature: null,
        expectThirdStageTemperature: null,
        averageThirdStageTemperature: null,
        initialStageTemperatureQualifiedRate: null,
        initialStageTemperatureUnderQualifiedRate: null,
        paveStageTemperatureQualifiedRate: null,
        paveStageTemperatureUnderQualifiedRate: null,
        initialStageTemperatureUnderQualifiedPileInfoList: null,
      },
      quality_4: {},
      quality_5: {},
      quality_6: {},
      overVoltagePileInfoList_BS: '', // 碾压遍数过压部分
      underVoltagePileInfoList_BS: '', // 碾压遍数欠压部分
      overVoltagePileInfoList_ICV: '', // ICV过压部分
      underVoltagePileInfoList_ICV: '', // ICV欠压部分
      srcList_1: [],
      imageUrl_1: [],
      srcList_2: [],
      imageUrl_2: [],
      srcList_3: [],
      imageUrl_3: [],
      projectTypeShow: 0,
      pdfName: '',
    };
  },
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.getProjectList();
  },
  methods: {
    async download() { // 下载使用说明书
      if (this.workId == '') {
        Message.error('请选择作业！')
        return
      }

      let userRoleList = localStorage.getItem("userRoleList")
      if (userRoleList.indexOf("menu-1eb5389fa0be4e2a8b0c7bd978aab346") < 0) {
        Message.error('您没有权限，可联系管理员添加权限！')
        return
      }
      this.downloadExcelShow = false

      this.loadingInstance = Loading.service({ text: '下载中...' });
      let params = {
        workId: this.workId
      };
      const InstructionManualvv = await getWorkQualityReportPdf(params);
      let blob = new Blob([InstructionManualvv.data], { type: 'application/pdf;charset=UTF-8' });
      let str = this.pdfName?(this.pdfName + '-' + this.projectInfoVo.timePeriod.slice(0, 10)):(this.projectInfoVo.timePeriod.slice(0, 10))
      // console.log("str==",str,"           this.name=",this.pdfName)
      let fileName = str + '-作业质量报表' + getDateSeconds() + '.pdf';
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName)
      } else {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href) //释放内存
      }
      this.downloadExcelShow = true
      this.loadingInstance.close();
    },
    //跳转到作业回放界面
    goToMonitorRe(){
      this.$router.push({ name: "MonitorRe" });

    },
    openProjectSelector() {
      this.dialogTableVisible = true;
      // this.getProjectList();
    },
    getProjectList() {
      // 获取条件筛选数据

      getEnginList({ pageSize: 1000 }, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
        const currentProject = (this.projList || []).find(
          (item) => item.active == 1
        );
        this.projectId = currentProject.id;
        this.nowPro = currentProject.name;
        this.projectTypeShow = currentProject.projectType;
        this.$store.commit("setProjectId", this.projectId);
        getWorks({ projectId: currentProject.id }).then((res) => {
          this.workList = res.data.content.info.list;
          this.workId = this.workList[0].id;
          this.doSearchClick()
        })
      });
    },
    toActive: function (setId) {
      let params = {
        id: setId,
      };
      activeEngin(params).then((res) => {
        console.log(res);
        this.getProjectList();
      });
    },
    doSearchClick() {
      getWorkQualityReport({
        workId: this.workId
      }).then((res) => {
        this.dataList = res.data.content.info.equipPerformanceInfoVoList
        this.projectInfoVo = res.data.content.info.projectInfoVo
        this.pdfName = res.data.content.info.name
        this.qualityIndicatorVoList = res.data.content.info.qualityIndicatorVoList
        // console.log("this.projectInfoVo.timePeriod.slice(0,10)", this.projectInfoVo.timePeriod.slice(0, 10))

        this.quality_1 = this.qualityIndicatorVoList[0] ? this.qualityIndicatorVoList[0] : null
        this.quality_2 = this.qualityIndicatorVoList[1] ? this.qualityIndicatorVoList[1] : null
        this.quality_3 = this.qualityIndicatorVoList[2] ? this.qualityIndicatorVoList[2] : this.quality_3
        this.quality_4 = this.qualityIndicatorVoList[3] ? this.qualityIndicatorVoList[3] : null
        this.quality_5 = this.qualityIndicatorVoList[4] ? this.qualityIndicatorVoList[4] : null
        this.quality_6 = this.qualityIndicatorVoList[5] ? this.qualityIndicatorVoList[5] : null
        this.imageUrl_1 = this.quality_1.rollNumDistributionMapImageUrl
        this.srcList_1 = [this.imageUrl_1]
        this.imageUrl_2 = this.quality_2.rollIcvDistributionMapImageUrl
        this.srcList_2 = [this.imageUrl_2]
        this.imageUrl_3 = this.projectTypeShow ? '' : this.quality_3.paveTemperatureDistributionMapImageUrl
        this.srcList_3 = [this.imageUrl_3]

        this.overVoltagePileInfoList_BS = this.quality_1 ? this.listToString(this.projectTypeShow ? this.quality_1.overVoltageCoordinateList : this.quality_1.overVoltagePileInfoList, 1, this.projectTypeShow) : ''
        this.underVoltagePileInfoList_BS = this.quality_1 ? this.listToString(this.projectTypeShow ? this.quality_1.underVoltageCoordinateList : this.quality_1.underVoltagePileInfoList, 1, this.projectTypeShow) : ''
        this.overVoltagePileInfoList_ICV = this.quality_2 ? this.listToString(this.projectTypeShow ? this.quality_2.overVoltageCoordinateList : this.quality_2.overVoltagePileInfoList, 2, this.projectTypeShow) : ''
        this.underVoltagePileInfoList_ICV = this.quality_2 ? this.listToString(this.projectTypeShow ? this.quality_2.underVoltageCoordinateList : this.quality_2.underVoltagePileInfoList, 2, this.projectTypeShow) : ''
      })
    },
    listToString(list, type, projectType) {
      let str = ''
      if (list.length > 0) {
        if (type == 1) {
          if (projectType == 1) {
            for (let i = 0; i < list.length; i++) {
              str = str + '{x:' + list[i].coordinateX + ',' + 'y:' + list[i].coordinateY + '}(' + list[i].offset + '遍);' + ' '
            }
          } else {
            for (let i = 0; i < list.length; i++) {
              let pile = ((list[i].pileNum / 1000).toFixed(3) + '').split('.')
              str = str + 'K' + pile[0] + '+' + pile[1] + '(' + list[i].offset + '遍' + ');' + ' '
            }
          }

        }
        if (type == 2) {
          if (projectType == 1) {
            for (let i = 0; i < list.length; i++) {
              str = str + '{x:' + list[i].coordinateX + ',' + 'y:' + list[i].coordinateY + '}; ' + ' '
            }
          } else {
            for (let i = 0; i < list.length; i++) {
              let pile = ((list[i].pileNum / 1000).toFixed(3) + '').split('.')
              str = str + 'K' + pile[0] + '+' + pile[1] + '(' + list[i].offset + '' + ');' + ' '
            }
          }
        }
      } else {
        str = '--'
      }

      return str
    },

    numberMul(overSpeedRatio) {
      if (overSpeedRatio) {
        let number = overSpeedRatio * 100
        number = Math.ceil(number)
        return number
      }
    },
    goBack: function () {
      this.$router.push({ name: 'EngineeringCenter' });
    },
  },
  components: {
    RollLegend,
  },
};
</script>
<style lang="scss">
.searchCon {
  .el-input {
    width: 224px;
    margin-left: 16px;
  }

  .el-date-editor {
    margin-left: 16px;
  }

  .el-input__inner {
    // margin-left: 16px;
  }

  .el-button {
    margin-left: 16px;
  }
}
</style>
<style lang="scss">
.listContain {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}

.listContentDay {
  height: auto;
  width: 98.5%;
  margin: 0 auto;
  //   background-color: #ffffff;
  position: relative;
  padding-top: 63px;

  .searchCon {
    width: 100%;
    height: 63px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .changePro {
    position: absolute;
    width: 88px;
    height: 32px;
    text-align: center;
    font-size: 14px;
    right: 106px;
    top: -45px;
    z-index: 500;
  }

  .qualityCon {
    width: 100%;
    height: auto;
    background-color: #ffffff;
    padding: 0 24px;

    .projectInfo {
      height: auto;
      padding-bottom: 24px;
      margin: 0 auto;
      background-color: #ffffff;

      .blockHeader {
        width: 100%;
        height: 58px;
        position: relative;

        .redBlock {
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #e96b5a;
          top: 19px;
          left: 0px;
        }

        .headerText {
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 14px;
          font-weight: 600;
          font-size: 16px;
        }
      }

      .smallHeaderText {
        height: 14px;
        line-height: 14px;
        color: #333333;
        display: inline-block;
        //   font-weight: 600;
        font-size: 16px;
        margin-top: 20px;
      }

      .imageShow {
        width: 100%;
        height: 320px;
        overflow-y: scroll;
        position: relative;
        // background: rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
        margin-top: 16px
      }

      .blockContent {
        margin: 0 auto;
        border-top: 1px solid rgba(225, 225, 225, 1);
        border-left: 1px solid rgba(225, 225, 225, 1);

        .blockItem {
          display: flex;
          height: 45px;

          .item_type1 {
            flex: 1;
          }

          .item_type2 {
            flex: 2;
          }

          .itemLeft {
            width: 150px;
            height: 44px;
            float: left;
            background: rgba(242, 242, 245, 1);
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);
            line-height: 44px;
            padding-left: 15px;
            color: #555555;
            font-size: 14px;
          }

          .itemRight {
            // width: 100%;
            height: 44px;
            line-height: 44px;
            padding-left: 18px;
            color: #555555;
            font-size: 14px;

            overflow: hidden;
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);

            .infoShow {
              width: 100%;
              height: 100%;
              border: 0;
              color: #555555;
              font-size: 14px;
              display: block;
            }

            .infoShowT {
              width: 100%;
              height: 100%;
              border: 0;
              color: #555555;
              font-size: 14px;
              display: block;
              overflow: hidden;
              overflow-y: auto;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}

.changeText {
  line-height: 28px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  right: 225px;
  top: -42px;
  z-index: 400;
}

.returnFunc {
  // position: fixed;
  top: 115px;
  right: 15px;
  z-index: 1000;
}

.workBack {
  position: absolute;
  width: 88px;
  height: 32px;
  text-align: center;
  font-size: 14px;
  right: 120px;
  top: 60px;
  z-index: 500;
}
.lookUp {
  position: absolute;
  width: 88px;
  height: 32px;
  text-align: center;
  font-size: 14px;
  top: 60px;
  z-index: 500;
  right: 16px;
}

.lookUp_1 {
  position: absolute;
  width: 88px;
  height: 32px;
  text-align: center;
  font-size: 14px;
  right: 0;
  top: 0px;
  z-index: 500;
}
.goBack {
  position: absolute;
  right: 16px;
  top: 12px;
  z-index: 1000;
  width: 88px;
  height: 32px;
}

.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}

.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}

.rollLegend {
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 50;
}
</style>